/** @badge Native — TG UI Button
 *  @when   основное действие экрана: одна на секцию, fullWidth по умолчанию (stretched)
 *  @not    кнопка только с иконкой — это IconButton · пункт списка/выбор — это Cell
 *  @breaks loading=true без disabled=true не блокирует клик — onClick и haptic всё равно сработают
 */
"use client";

import { forwardRef, ReactNode } from "react";
import { Button as TGButton } from "@telegram-apps/telegram-ui";
import { haptic } from "@kit/hooks/useHaptic";

type ButtonVariant = "default" | "destructive" | "ghost" | "outline";

interface ButtonProps {
  variant?: ButtonVariant;
  onClick?: () => void;
  fullWidth?: boolean;
  disabled?: boolean;
  loading?: boolean;
  size?: "s" | "m" | "l";
  before?: ReactNode;
  children?: ReactNode;
  style?: React.CSSProperties;
}

const modeMap: Record<ButtonVariant, "filled" | "plain" | "gray" | "outline"> = {
  default: "filled",
  destructive: "filled",
  ghost: "plain",
  outline: "outline",
};

const hapticMap: Record<ButtonVariant, "medium" | "heavy" | "light"> = {
  default: "medium",
  destructive: "heavy",
  ghost: "light",
  outline: "medium",
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = "default", onClick, fullWidth = true, children, disabled, loading, size, before, style }, ref) => (
    <TGButton
      ref={ref as any}
      mode={modeMap[variant]}
      size={size}
      before={before}
      loading={loading}
      stretched={fullWidth}
      disabled={disabled}
      onClick={() => { if (!disabled) { haptic(hapticMap[variant]); onClick?.(); } }}
      style={style}
    >
      {children}
    </TGButton>
  )
);

Button.displayName = "Button";
